import axios from 'axios';
import _ from 'lodash';

import { authenticationLogout } from './authentication';
import { buildFormData } from '../../lib/UtilityHelper';

export let instance = null;

export const actionStart = (actionType, accessToken, data) => {
    let base_url = process.env.REACT_APP_WEBAPI_BASE;

    if (process.env.REACT_APP_ENV === 'staging') {
        base_url = process.env.REACT_APP_WEBAPI_STAGING;
    } else if (process.env.REACT_APP_ENV === 'test') {
        base_url = process.env.REACT_APP_WEBAPI_TEST;
    } else if (process.env.REACT_APP_ENV === 'production') {
        base_url = process.env.REACT_APP_WEBAPI_PRODUCTION;
    }

    instance = axios.create({
        baseURL: base_url,
        headers: {
            'Authorization': 'Bearer ' + accessToken
        }
    });

    return {
        type: actionType,
        data: data
    };
};

export const actionSuccess = (actionType, data) => {
    return {
        type: actionType,
        data: data
    };
};

export const actionFail = (actionType, error) => {
    return (dispatch) => {
        const status = !_.isEmpty(error) && !_.isEmpty(error.response) ? error.response.status : 500;
        let message = !_.isEmpty(error) && !_.isEmpty(error.response) && !_.isEmpty(error.response.data) && !_.isEmpty(error.response.data.message) ? error.response.data.message : null;
        if (_.isEmpty(message)) {
            message = _.isEmpty(message) && !_.isEmpty(error.response) ? error.response.statusText : "Oops! Something went wrong!";
        }
        if (status === 401) { dispatch(authenticationLogout()); }
        return {
            type: actionType,
            error: {
                status: status,
                message: message
            }
        };
    };
};

export const actionExecute = (dispatch, getState, options) => {
    const accessToken = getState().authentication.accessToken;

    if (options.startFn) {
        dispatch(options.startFn(accessToken));
    } else {
        throw new Error('startFn was not provided and is required.');
    }

    let asyncFunc = null;
    let payload = options.payload;

    switch (options.type) {
        case 'delete': {
            asyncFunc = instance.delete(options.url);
            break;
        }
        case 'create':
        case 'post':
        case 'put':
        case 'update': {
            let formData = ((options.files && options.files.length > 0) || options.multiPart) ? new FormData() : null;

            if (options.files && options.files.length > 0) {
                for (var iu = 0; iu < options.files.length; iu++) {
                    let name = 'file';

                    if (iu > 0) { name += '_' + iu; }

                    formData.append(name, options.files[iu]);
                }
            }

            if ((options.files && options.files.length > 0) || options.multiPart) {
                if (options.payload) {
                    buildFormData(formData, options.payload);
                }

                payload = formData;
            }

            if (options.type === 'create' || options.type === 'post') {
                asyncFunc = instance.post(options.url, payload);
            } else {
                asyncFunc = instance.put(options.url, payload);
            }
            break;
        }
        default: {
            asyncFunc = instance.get(options.url);
            break;
        }
    }

    asyncFunc.then((response) => {
        if (options.successFn) {
            dispatch(options.successFn(response));
        }
    })
        .catch((error) => {
            if (options.failFn) {
                dispatch(options.failFn(error));
                return (dispatch(options.failFn(error)));
            }
        });
};